export default function range(min: number, max: number) {
  if (min > max) {
    return [];
  }

  const result = [];

  for (let i = min; i <= max; i++) {
    result.push(i);
  }

  return result;
}
